module.exports = __webpack_public_path__ + "static/logo12-3c7700f960a97d3963e326d7f3976390.png";